module.exports = __webpack_public_path__ + "media/images/back-5a3ce8ed35dfdca436cff6b3abe48053.png";